import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "../../setup/routes-manager";
import { AuthProvider } from "../../common/context/AuthProvider";
import PostHogAnalytics from "../../analytics/PostHogAnalytics";



const Container = () => {
  return (
    <>
      <Router>
        <AuthProvider>
            <PostHogAnalytics />
            <Routes />
        </AuthProvider>     
      </Router>
    </>
  );
};

export default Container;
